import Box from "@mui/material/Box";
import { useState, useEffect } from 'react';
import Button from "@mui/material/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";


const getUrl = window.location;
const baseUrl = getUrl.protocol + "//" + getUrl.host

export const VideoSection = () => {
   const [url, setUrl] = useState("https://www.youtube.com/embed/Fl0Ky_8K7Wo?autoplay=1&mute=1")
   const [chevron, setChevron] = useState(0);
   const [margin1, setMargin1] = useState("0vw");

   useEffect(() => {
      setUrl("https://www.youtube.com/embed/Fl0Ky_8K7Wo?autoplay=1&mute=1")
   }, [])
   return (
      <>
         <Box className="video-sec-web" sx={{ flexGrow: 1 }}>
            <div style={{ display: 'flex', width: '100%', height: '50vh' }}>
               <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: "#7C2387", flex: 1, flexDirection: 'column', gap: "5%" }}>
                  <h1 style={{ color: "white", fontWeight: "900" }}>
                     MEET THE RIGHT PEOPLE
                  </h1>
                  <h5 style={{ width: '45%', color: 'white' }}>Join the exclusive community of 1000+ top-tier VC Investors and leading startup Founders. Send direct messages and schedule 1 on 1 meetings with our Event App.</h5>

                  <a href={`https://youngstartup.com/upcoming`}>
                     {/* <Button className="dark-btn" sx={{borderRadius:'0px', backgroundColor:'#7C2387', fontFamily: 'Poppins, sans-serif !important', "&:hover":{backgroundColor:'#7C2387'}}} variant="contained">Register</Button> */}
                     <Button
                        onMouseOver={(e) => {
                           setChevron(1);
                           setMargin1("1.5vw");
                        }}
                        onMouseLeave={() => {
                           setChevron(0);
                           setMargin1("0vw");
                        }}
                        className="dark-btn"
                        sx={{ fontWeight: "900", fontSize: '1.25rem', color: "#7C2387 !important", backgroundColor: 'white !important', "&:hover": { backgroundColor: 'white !important', color: "#7C2387 !important" } }}

                     >
                        <div style={{ display: "flex", alignItems: 'center' }}>
                           <ChevronRightIcon sx={{ opacity: "0" }} />
                           <div>Matchmaking</div>
                           <ChevronRightIcon
                              sx={{
                                 transition: ".3s all ease-in-out",
                                 opacity: chevron,
                                 marginLeft: margin1,
                              }}
                           />
                        </div>
                     </Button>
                  </a>
               </div>
               <iframe style={{ flex: 1 }} src={url} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>

         </Box>
         <Box className="video-sec-mobile">
            <iframe style={{ flex: 1 }} src={url} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
 
         </Box>
      </>
   );
};

